import { fractionsV2Ops } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("fraction-preset"),
  endpoint: "fractions",
  operations: fractionsV2Ops,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  dependencies: ["container"],
  singularName: (t) => t("Fraction"),
  name: (t) => t("Fractions"),
  syncCustomerFilter: true,
  sendCulture: true,
  apiVersion: "v2",
});

export default conf;
